import { motion } from "framer-motion";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";


import { routes } from "../../utils/routes";

export const Navbar = ({ handleBackgroundChange }: any) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { t, i18n } = useTranslation();


  const menuVariants = {
    hidden: { opacity: 0, y: -20, scale: 0.95 },
    visible: { opacity: 1, y: 0, scale: 1 },
  };

  const toggleLanguage = () => {
    let newLang;
    if (i18n.language === "en") {
      newLang = "pt";
    } else if (i18n.language === "pt") {
      newLang = "ja";
    } else {
      newLang = "en";
    }
    i18n.changeLanguage(newLang);
  };



  return (
    <nav className="text-white p-4 md:p-6 z-20 absolute top-0 left-0 right-0">
      <div className="flex justify-between items-center">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center"
          onClick={handleBackgroundChange}
        >
          <img src="/imab_logo_green.png" alt="Logo" className="h-8 xl:h-10 mr-2 hover:scale-110 transition-all" />
        </Link>

        {/* Burger Icon */}
        <div className="lg:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="flex flex-col justify-between h-4 w-5 focus:outline-none"
          >
            <span
              className={`block w-5 h-0.5 bg-white transition-transform ${
                menuOpen ? "transform rotate-45 translate-y-2" : ""
              }`}
            ></span>
            <span
              className={`block w-5 h-0.5 bg-white transition-opacity ${
                menuOpen ? "opacity-0" : ""
              }`}
            ></span>
            <span
              className={`block w-5 h-0.5 bg-white transition-transform ${
                menuOpen ? "transform -rotate-45 -translate-y-2" : ""
              }`}
            ></span>
          </button>
        </div>

        {/* Navigation Links */}
        <motion.div
          className="lg:flex lg:gap-8 flex-col lg:flex-row items-center absolute lg:relative top-full right-0 w-1/3 lg:w-auto bg-black/60 lg:bg-transparent p-4 lg:p-0 rounded-md"
          initial="hidden"
          animate={menuOpen || window.innerWidth >= 1024 ? "visible" : "hidden"}
          variants={menuVariants}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          style={{
            display: menuOpen || window.innerWidth >= 1024 ? "flex" : "none",
          }}
        >
          {routes.map((route) => (
            <Link
              key={route.path}
              to={route.path}
              className={`hover:underline text-lg font-semibold ${
                location.pathname === route.path ? "text-green-400" : ""
              } hover:scale-105 active:scale-100 transition-transform duration-200 mb-4 lg:mb-0`}
              onClick={() => {
                setMenuOpen(false);
                if (route.path === "/portfolio") {
                  handleBackgroundChange(0);
                } else {
                  handleBackgroundChange();
                }
              }}
            >
              {t(route.nameKey)}
            </Link>
          ))}

          {/* Language Toggle */}
          <button
            onClick={toggleLanguage}
            className="flex items-center gap-1.5 text-sm font-semibold text-gray-300 hover:text-white transition-all mb-4 lg:mb-0"
            aria-label="Toggle language"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <path d="M2 12h20" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
            {i18n.language === "pt" ? "PT" : i18n.language === "ja" ? "JA" : "EN"}
          </button>


        </motion.div>
      </div>
    </nav>
  );
};
